import { isFunction } from "../types/function";
import * as React from 'react';
import { useCallback, useState } from 'react';
import { Container, Input, Label } from "./styles";











const defaultProps = {
  className: '',
  disabled: false,
  color: '#fff',
  onChange: () => void 0,
  intermediate: false };


const Toggle = ({
  id,
  className,
  color = defaultProps.color,
  disabled = defaultProps.disabled,
  onChange = defaultProps.onChange,
  intermediate = defaultProps.intermediate,
  checked }) =>
{
  const [value, setValue] = useState(Boolean(checked) || false);

  const handleChange = useCallback(() => {
    if (disabled) return;
    if (isFunction(onChange)) {
      onChange(!value);
    }
    setValue((v) => !v);
  }, [onChange, value, disabled]);

  return /*#__PURE__*/(
    React.createElement(Container, { className: className, disabled: disabled }, /*#__PURE__*/
    React.createElement(Input, {

      id: id,
      type: "checkbox",
      checked: checked,
      disabled: disabled,
      accentColor: color,
      onChange: handleChange,
      intermediate: intermediate }), /*#__PURE__*/

    React.createElement(Label, { htmlFor: id })));


};

export { Toggle };